import { ProductDetailDrawerRequestDto, QuotesClient } from "@lib/ShiOneClient";
import { useQuery } from "@tanstack/react-query";
import { useApi } from "@utils/index";
import ms from "ms";

export function useGetQuoteProductDetailDrawerImages(
  request: ProductDetailDrawerRequestDto | null,
  fallbackImages: boolean,
) {
  const quotesApi = useApi(QuotesClient);

  return useQuery({
    queryKey: [
      "ecommerce-quote-product-detail-drawer-images",
      {
        productDescriptor: request?.productDescriptor,
        productClass: request?.productClass,
        cNetProductId: request?.cNetProductId,
      },
    ],
    queryFn: async () => {
      if (!request) {
        throw new Error("ProductDetailDrawerRequest is required");
      }
      return await quotesApi.getQuoteProductDetailDrawerImages(request);
    },
    enabled: fallbackImages && !!request,
    staleTime: ms("1m"),
    retry: false,
  });
}
